import { useId, type ReactNode } from "react";

/** A section of a Finance drawer under a heading of its own, which names it for a screen reader too. */
export function DrawerSection({ title, children }: { readonly title: string; readonly children: ReactNode }) {
	const headingId = useId();
	return (
		<section aria-labelledby={headingId} className="flex flex-col gap-2">
			<h3 id={headingId} className="text-ctl font-semibold text-ink">
				{title}
			</h3>
			{children}
		</section>
	);
}
